export default __webpack_public_path__ + "c8d440004febc96876b1bf34aa78ac60.png";